import React from 'react'
import { btnPrimary } from '../knowledgePageLayout'
import AgentClientPicker from './AgentClientPicker'
import { agentColors, glassInputStyle } from './agentChatLayout'

export default function AgentComposer({
  input,
  setInput,
  onSend,
  onStop,
  sending,
  clientId,
  setClientId,
  clients,
  includePersonal,
  setIncludePersonal,
  personalKbAvailable,
}) {
  return (
    <div
      style={{
        padding: '12px 16px 16px',
        borderTop: '1px solid rgba(255,255,255,0.45)',
        background: 'rgba(255,255,255,0.32)',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 12,
          marginBottom: 10,
          fontSize: 12,
          color: agentColors.textSecondary,
          alignItems: 'center',
        }}
      >
        <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          Client
          <AgentClientPicker
            clients={clients}
            clientId={clientId}
            setClientId={setClientId}
            disabled={sending}
          />
        </label>
        {personalKbAvailable ? (
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={includePersonal}
              onChange={(e) => setIncludePersonal(e.target.checked)}
              disabled={sending}
            />
            Personal library
          </label>
        ) : null}
      </div>
      <div style={{ display: 'flex', gap: 10 }}>
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              if (!sending) onSend()
            }
          }}
          placeholder="Message…"
          disabled={sending}
          rows={2}
          style={{
            flex: 1,
            padding: '12px 14px',
            borderRadius: 10,
            fontSize: 14,
            resize: 'none',
            fontFamily: 'inherit',
            lineHeight: 1.5,
            ...glassInputStyle,
          }}
        />
        <button
          type="button"
          style={{
            ...(sending ? {} : btnPrimary),
            alignSelf: 'flex-end',
            padding: '12px 20px',
            borderRadius: 10,
            ...(sending
              ? {
                  background: 'transparent',
                  border: `1px solid ${agentColors.accent}`,
                  color: agentColors.accent,
                }
              : {
                  background: agentColors.accent,
                  border: 'none',
                }),
            opacity: sending ? 1 : !input.trim() ? 0.6 : 1,
          }}
          disabled={!sending && !input.trim()}
          onClick={sending ? onStop : onSend}
        >
          {sending ? 'Stop' : 'Send'}
        </button>
      </div>
    </div>
  )
}
